import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import analytics from '../../utils/analytics';

const RESULT_SCREEN_MIN_HEIGHT = 200;

type CreditLineRejectedScreenProps = {
  hardFilters: undefined | { [key: string]: string },
  isRegistered: boolean,
};

export default function CreditLineRejectedScreen({
  hardFilters,
  isRegistered,
}: CreditLineRejectedScreenProps) {
  React.useEffect(() => {
    analytics.page('BNPL - REGISTRO', isRegistered ? 'RECHAZADO - CON SUBSCRIPCION' : 'RECHAZADO - SIN SUBSCRIPCION', { ...(hardFilters || {}) });
  }, []);

  return (
    <div>
      <Box
        sx={{
          minHeight: RESULT_SCREEN_MIN_HEIGHT,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <Typography
          variant="h5"
          align="center"
          component="div"
          gutterBottom
        >
          <b>No has sido aprobado/a con banca.me en esta ocasión</b>
        </Typography>
        <Typography
          variant="h6"
          align="center"
          component="div"
        >
          Las condiciones cambian según tu historial de pagos, tus ingresos y deudas actuales,
          así que te invitamos a intentarlo más adelante.
        </Typography>
      </Box>
      <div style={{ textAlign: 'center' }}>
        <Button
          variant="contained"
          color="primary"
          href="https://www.banca.me"
          target="_blank"
          rel="noopener noreferrer"
        >
          Ir a banca.me
        </Button>
      </div>
    </div>
  );
}
